import React, { Fragment } from "react";
import { connect } from "react-redux";
import { push as pushLocation } from "react-router-redux";
import { startQuickPay } from "../../../../domain/validation/validationActions";
import * as Icons from "./Icons";
import { FormattedMessage } from "react-intl";
import StatusMessage from "../../../presentational/StatusMessage";
import classNames from "classnames";
import { Link } from "react-router";
const options = (props) => {
    return (<Fragment>
			<div className="newUserOptions">
				<div style={{ textAlign: "center", marginBottom: "50px", fontSize: "20px" }}>
					<FormattedMessage tagName="h1" id="newuser.options.message" defaultMessage="You have two options to continue"/>
				</div>
				<ul className="icons">
					<li>
						<Link className={classNames("link", {
        link_isDisabled: props.tokenLoading
    })} to="/public/validation">
							{Icons.REGISTER}
							<span style={{ textAlign: "center" }}>
								<FormattedMessage id="newuser.options.register" defaultMessage="Register for full account access"/>
							</span>
						</Link>
					</li>
					<li>
						<button className={classNames("link", {
        link_isDisabled: props.tokenLoading
    })} onClick={() => props.onQuickPay()}>
							{Icons.QUICKPAY}
							<span style={{ textAlign: "center" }}>
								<FormattedMessage id="newuser.options.quickpay" defaultMessage="Make a quick payment"/>
							</span>
						</button>
					</li>
				</ul>
			</div>
			<div className={`wrapper wrapper_narrowPlus`}>
				<StatusMessage isLoad isActive={props.tokenLoading} domain="validation"/>
			</div>
		</Fragment>);
};
export default connect((state) => ({
    tokenLoading: state.validation.tokenLoading
}), {
    onQuickPay: startQuickPay,
    push: pushLocation
})(options);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/NewUserOptions.tsx